import { Localized } from "@fluent/react";
import { LinearProgress } from "@mui/material";
import { useEffect } from "react";
import { getInviteSummarys, deleteInvite, resendInvitationMail } from "../../store/thunk/inviteSummary";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { RejectionReason } from "../../store/slices/alarmGroup";
import InviteSummaryList from "../ui/InviteSummaryList";

export default function InviteSummary() {
	const dispatch = useAppDispatch();
	const inviteSummary = useAppSelector(state => state.inviteSummary);
	
	const onDeleteInvite = ( inviteId: string) => {
		dispatch(deleteInvite(inviteId));
  	};	

	const onResendInvitationMail = async (email: string, org_id: string) => {
		try {
			dispatch(resendInvitationMail(email, org_id ));
		} catch (e) {
			console.log("resend email error is ", e);
		}
	};


	useEffect(() => {
		// If we don't have data yet and not attempt was made to request it,
		// dispatch a request to get the data of the users within the organization in the state.
		if (inviteSummary.kind === "initializing"
			&& !inviteSummary.pending && inviteSummary.rejectionReason === undefined) {
			dispatch(getInviteSummarys());
		}
	}, [dispatch, inviteSummary]);

	switch (inviteSummary.kind) {
		case 'initializing':
			if (inviteSummary.rejectionReason !== undefined) {
				switch (inviteSummary.rejectionReason) {
					case RejectionReason.Network:
						return <Localized id="loading-failed-network" />;
					case RejectionReason.Bug:
						return <Localized id="loading-failed-bug" />;
				}
			}

			return <LinearProgress sx={{ height: "8px" }} />;
		case 'ready':
			return <>
				<InviteSummaryList 
					users={inviteSummary.inviteSummarys}
					onDeleteInvite={onDeleteInvite}
					onResendInvitationMail={onResendInvitationMail}
					/>
			</>;
	}
}
